import React, { useState, useEffect } from "react";
import { Slider } from "../../../shadcn/components/ui/slider";
import { Input } from "../../../shadcn/components/ui/input";

/*
 *   <PriceRangeSelector
          range={[0, 50000000]}
          defaultSelectedRange={[10000000, 50000000]}
          minStepsBetweenThumbs={500}
          step={500}
        />
 */
interface PriceRangeSelectorProps {
  range: [any, any];
  defaultSelectedRange: [any, any];
  minStepsBetweenThumbs: number;
  step: number;
  setSelectedRange: any;
}
export default function PriceRangeSelector({
  range,
  step,
  minStepsBetweenThumbs,
  defaultSelectedRange,
  setSelectedRange,
}: PriceRangeSelectorProps) {
  const [rangeValue, setRangeValue] = useState(defaultSelectedRange);
  const [minInputError, setMinInputError] = useState("");
  const [maxInputError, setMaxInputError] = useState("");

  const handleValueChange = (value: [number, number]) => {
    console.log("value: ", value);
    setRangeValue(value);
    setMinInputError("");
    setMaxInputError("");
  };
  useEffect(() => {
    setSelectedRange(rangeValue);
  }, [rangeValue]);

  const handleValueInputChange = (type: "min" | "max", value: any) => {
    const parsedValue = parseInt(value as unknown as string, 10);
    if (value.length > 11) return;
    if (type === "max") {
      if (parsedValue >= rangeValue[0]) {
        setRangeValue([rangeValue[0], parsedValue]);
        setMaxInputError("");
        setMinInputError("");
      } else if (parsedValue) {
        setRangeValue([parsedValue, parsedValue]);
        setMaxInputError("Min cannot exceeds max.");
        setMinInputError("");
      } else {
        setRangeValue([0, parsedValue]);
        setMaxInputError("Min cannot exceeds max.");
        setMinInputError("");
      }
    } else if (type === "min") {
      if (parsedValue <= rangeValue[1]) {
        setRangeValue([parsedValue, rangeValue[1]]);
        setMinInputError("");
        setMaxInputError("");
      } else if (parsedValue) {
        setRangeValue([parsedValue, parsedValue]);
        setMinInputError("Min cannot exceeds max.");
        setMaxInputError("");
      } else if (!parsedValue) {
        setRangeValue([parsedValue, rangeValue[1]]);
        setMinInputError("Min cannot exceeds max.");
        setMaxInputError("");
      }
    }
  };

  return (
    <div className="flex flex-col items-center py-4 px-5">
      <Slider
        minStepsBetweenThumbs={minStepsBetweenThumbs}
        min={range[0] || 0}
        max={range[1] || 500000}
        step={step}
        value={rangeValue}
        onValueChange={handleValueChange}
      />

      <section className="flex w-full justify-between mt-[5px]">
        <div className="flex flex-col justify-center items-center">
          <span className="h-[10px] border-[1px]"></span>
          <span className="text-[10px] pl-1 font-openSans text-brand-borderGrey font-semibold">
            0
          </span>
        </div>
        {/* <div className="flex flex-col justify-center items-center">
          <span className="h-[10px] border-[1px]"></span>
          <span className="text-[10px] font-openSans text-brand-borderGrey font-semibold">
            ₹ 1 Cr
          </span>
        </div>
        <div className="flex flex-col justify-center items-center">
          <span className="h-[10px] border-[1px]"></span>
          <span className="text-[10px] font-openSans text-brand-borderGrey font-semibold">
            ₹ 5 Cr
          </span>
        </div>
        <div className="flex flex-col justify-center items-center">
          <span className="h-[10px] border-[1px]"></span>
          <span className="text-[10px] font-openSans text-brand-borderGrey font-semibold">
            {" "}
            ₹ 10 Cr
          </span>
        </div>
        <div className="flex flex-col justify-center items-center">
          <span className="h-[10px] border-[1px]"></span>
          <span className="text-[10px] font-openSans text-brand-borderGrey font-semibold">
            {" "}
            ₹ 100 Cr
          </span>
        </div> */}
        <div className="flex flex-col justify-center items-center">
          <span className="h-[10px] border-[1px]"></span>
          <span className="text-[10px] font-openSans text-brand-borderGrey font-semibold">
            ₹ 250 Cr+
          </span>
        </div>
      </section>
      <section className="flex w-full justify-between items-center mt-5">
        <div className="flex flex-col">
          <div className="text-[10px] font-openSans font-semibold text-brand-textBlack">
            Min
          </div>
          <div className="border-2 rounded-lg pl-4 mt-1">
            <span className="text-xs font-openSans text-brand-textBlack">
              ₹
            </span>
            <Input
              type="number"
              placeholder="Enter amount"
              className="text-xs font-openSans text-brand-borderGrey border-0 focus:border-0 rounded-lg py-[6px] ml-1 px-1 max-w-28"
              value={rangeValue[0]}
              onChange={(e) => handleValueInputChange("min", e.target.value)}
            />
          </div>

          <div className="text-[10px] text-brand-textRed font-openSans h-2">
            {minInputError}
          </div>
        </div>
        <div className="flex flex-col">
          <div className="text-[10px] font-openSans font-semibold text-brand-textBlack">
            Max
          </div>
          <div className="text-brand-borderGrey border-2 rounded-lg pl-4 mt-1">
            <span className="text-xs font-openSans text-brand-textBlack">
              ₹
            </span>
            <Input
              type="number"
              placeholder="Enter amount"
              className="text-xs font-openSans text-brand-borderGrey border-0 focus:border-0 rounded-lg py-[6px] ml-1 px-1 max-w-28"
              value={rangeValue[1]}
              onChange={(e) => handleValueInputChange("max", e.target.value)}
            />
          </div>

          <div className="text-[10px] text-brand-textRed font-openSans h-2">
            {maxInputError}
          </div>
        </div>
      </section>
    </div>
  );
}
